define('modules/page_generator/views/base_preview',['require','exports','module','base/view','../service','modules/editor/models/editorstate','ldsh!../templates/preview','ldsh!../templates/external_confirmation'],function (require, exports, module) {
  var BaseView = require("base/view"),
    PageGenerator = require("../service"),
    EditorState = require("modules/editor/models/editorstate");

  module.exports = BaseView.extend({
    template: require("ldsh!../templates/preview"),
    externalTemplate: require("ldsh!../templates/external_confirmation"),
    className: "ed-preview-wrapper",
    /**
     * Renders a Variant HTML content
     * @param  {string} page Either "content" or "confirmation"
     */
    renderContents: function (page) {
      var confirmationUrl, html, $iframe, iframeDoc;

      if (!this.model) {
        return;
      }

      $iframe = this._createIframe();
      iframeDoc = $iframe.get(0);

      confirmationUrl = this.model.getPropertyGroup("page:confirmation").get("confirmationUrl");
      if (confirmationUrl !== "" && page === "confirmation") {
        html = this.externalTemplate({
          message: $.i18n.t("editor.externalConfirmationPreviewMessage"),
          confirmationUrl: this.model.getPropertyGroup("page:confirmation").get("confirmationUrl")
        });
      } else {
        //render page
        html = PageGenerator.generatePreview(this.model, page);

        if (html === '') {
          return;
        }
      }

      //write iframe contents
      iframeDoc.contentDocument.write(html);
      iframeDoc.contentDocument.close();

      $iframe.i18n();

      if (EditorState.getAMPState()) {
        this._decorateAMPPreviewFrame();
      }

      //allow specific preview to modify the DOM
      this.triggerMethod("preview:render");
    },

    _decorateAMPPreviewFrame: function () {
      $('.js-preview-container').addClass('isAMP');
    },

    _createIframe: function () {
      var $container = this.$(".js-preview"),
        $iframe = $("<iframe />")
          .attr("src", "about:blank")
          .css("border", "none");

      //write frame
      $container.empty();
      $iframe.appendTo(this.$(".js-preview"));
      return $iframe;
    }
  });
});

